// extracted by mini-css-extract-plugin
export default {"summary-container":"DoctorCommissionProgramReportSummary_summary-container__+6u6d","summary-ctas":"DoctorCommissionProgramReportSummary_summary-ctas__bqAvY"};